import React from "react";
import ImgHeader from "../ImgHeader";
import { Container, Grid, Paper, Typography } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router";
import styled from "styled-components";
import { H1, H2, H3 } from "../Headers";
import LinkButton from "../LinkButton";
import ISupportCall from "../../models/ISupportCall";

interface ISubmitTicketConfirmation {
  serviceCall: ISupportCall;
}

const SubTitle = styled(H2)`
  margin-top: 0;
`;

const ThankYouPaper = styled(Paper)`
  margin: 3em 0;
  padding: 2em;
  text-align: center;
`;

const ThankYouParagraph = styled(Typography)`
  margin: 5px;
  padding: 5px;
`;

class SubmitTicketConfirmation extends React.Component<RouteComponentProps, ISubmitTicketConfirmation> {
  render() {
    let sc = this.props.location.state;
    return (
      <>
        <ImgHeader
          url="/static/img/kelly-sikkema-fvpgfw3IF1w-unsplash.jpg"
          shadowOpacity={0.4}
          mediaBreakpoints={[
            {
              minWidth: 0,
              leftOffset: "0",
              topOffset: "0",
            },
            {
              minWidth: 760,
              leftOffset: "0",
              topOffset: "-100px",
            },
            {
              minWidth: 1100,
              leftOffset: "0",
              topOffset: "-200px",
            },
            {
              minWidth: 1350,
              leftOffset: "0",
              topOffset: "-300px",
            },
            {
              minWidth: 1550,
              leftOffset: "0",
              topOffset: "-400px",
            },
            {
              minWidth: 1740,
              leftOffset: "0",
              topOffset: "-500px",
            },
          ]}
        >
          <H1>We've Received Your Support Ticket!</H1>
        </ImgHeader>
        <Container>
          <Grid container direction="column" alignItems="center" spacing={3}>
            <Grid item>
              <ThankYouPaper>
                <SubTitle>Support Ticket Received!</SubTitle>
                <ThankYouParagraph paragraph>One of our staff members will respond to you as soon as possible.</ThankYouParagraph>
                <ThankYouParagraph paragraph>To get updates on the status of your ticket please visit the Support Tickets page.</ThankYouParagraph>
                <LinkButton to="/list-sc">My Company's Support Tickets</LinkButton>
                <ThankYouParagraph paragraph>Your support ticket number is</ThankYouParagraph>
                <H3>{sc.Number}</H3>
              </ThankYouPaper>
            </Grid>
          </Grid>
        </Container>
      </>
    );
  }
}
export default withRouter(SubmitTicketConfirmation);
